import { create } from 'zustand'

/** Which review the table or a chat card asked for: the review drawer, its skip form, the draft's view, or the POD's own view. */
export type ReviewMode = 'review' | 'skip' | 'draft' | 'document'

interface InvoiceReviewState {
    /** The load whose review drawer is open, by load number, or null when none is. */
    loadNumber: string | null
    /** The load's id when the opener knows it (a chat card): the drawer reads the board's load by it before the invoicing row is in. */
    loadId: string | null
    /** The view the drawer opens on for that load. */
    mode: ReviewMode
    open: (loadNumber: string, mode?: ReviewMode, loadId?: string) => void
    close: () => void
}

/**
 * One review drawer at a time, the page's one right-hand panel: a table row's action or a chat card's "Review POD" / "Open paperwork"
 * opens it for its load. The host renders `InvoiceReviewDrawer` once.
 */
export const useInvoiceReview = create<InvoiceReviewState>((set) => ({
    loadNumber: null,
    loadId: null,
    mode: 'review',
    open: (loadNumber, mode = 'review', loadId) => set({ loadNumber, mode, loadId: loadId ?? null }),
    close: () => set({ loadNumber: null, loadId: null, mode: 'review' }),
}))
